import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pageList: [],
  pageFormList: [],
  pageDetail: [],
  loading: false,
  error: undefined,
  success: false,
  actionType: null,
};
const pageSlice = createSlice({
  name: "page",
  initialState,
  reducers: {
    clearError(state) {
      state.loading = false;
      state.success = false;
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
      state.actionType = null;
    },
    actionSuccess(state, action) {
      state.success = true;
      state.loading = false;
      state.actionType = action.payload || null;
    },
    fetchPageList(state, action) {
      state.pageList = action.payload;
      state.loading = false;
    },
    fetchPageDetail(state, action) {
      state.pageDetail = action.payload;
      state.loading = false;
    },
  },
});

export const pageActions = pageSlice.actions;

export default pageSlice.reducer;
